export default function wysiwygRevealInit() {
    const revealItemsObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                revealItemsObserver.unobserve(entry.target);
                entry.target.classList.add('is-reveal');
            }
        });
    });

    Array.from(document.querySelectorAll('.js-wysiwyg-reveal > *')).forEach((el) => {
        revealItemsObserver.observe(el);
    });
}
